export default __webpack_public_path__ + "static/media/Maddie.c8ee75d6.jpg";